const config = {
  Auth: {
    region: "eu-west-2",
    userPoolId: "eu-west-2_JTCGtVPV6",
    userPoolWebClientId: "7kfoeklep21g4cpfpv9qrmmmup",
  },
};

export default config;
